import $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css';
import TextField from 'material-ui/TextField';
import * as actions from '../../actions/actions.jsx';
import services from '../../services/allservices.jsx';
import { withRouter, Link } from 'react-router-dom';

import creditcardlogo from '../../images/credit-cards-vector-icon-.jpg';
import Loader from '../loader/loader.jsx';
import LoaderSmall from "../loader/loadersmall.jsx";
import UserModal from './regmodal.jsx';
import RaisedButton from 'material-ui/RaisedButton';
import GusetNavbar from '../navigation/guestnavbar';
import InputMask from 'react-input-mask';
import android from '../../images/android.png';
import ios from '../../images/ios.png';

import carousel1 from '../../images/carousel-1.jpg';
import carousel2 from '../../images/carousel-5.jpg';
import carousel3 from '../../images/carousel-3.jpg';
import carousel4 from '../../images/carousel-8.jpg';

import carousel5 from '../../images/carousel-6.jpg';
import carousel6 from '../../images/carousel-2.jpg';
import carousel7 from '../../images/carousel-7.jpg';
import carousel8 from '../../images/carousel-4.jpg';

import { getClientId, getClientSecret,buildClientHeader } from "../../../src/utils/clientAuth.js";
import uuidv4 from 'uuid/v4';
// import activateImg from '../../images/activateimg(NEW).jpg';
// import customerImg from '../../images/customerimg.jpg';
// import manageImg from '../../images/manageimg.jpg';

const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    activationcardState: state.getactivationcardReducer.activationcardState
})
const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    storeCardNumber(cardNumber) {
        dispatch(
            actions.storeCardDetail(cardNumber)
        )
    },
    getactivation(state) {

        dispatch(
            actions.getactivationcardAction(state)

        )
    },
})





const JSEncrypt = window.JSEncrypt
class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal : false,
            cardVerificationDone: false,
            mobileVerificationDone: false,
            mobiledisable: true,
            disabled: true,
            expiryDone: false,
            cardVerified: false,
            verification: false,
            rederFeedback: false,
            mobilecardVerified: false,
            mobileverification: false,
            mobilerederFeedback: false,
            mobile: '',
            open: false,
            loader: false,
            title: "Invalid Card Number",
            openModal: false,
            cardType: "",
            emailId : "",
            width: props.innerWidth,
            height: props.innerHeight,
            rndInt: 0
        };
        this.storeCard = this.storeCard.bind(this)
        this.updateWindowDimentions = this.updateWindowDimentions.bind(this);
    }
    componentDidMount() {
        this.props.fetchPublicKey(false)
        this.updateWindowDimentions();
        window.addEventListener('resize', this.updateWindowDimentions);
        // localStorage.setItem('landingTabs', 'cardNo')

        // document.getElementById("cardNumber").focus()
        this.setState({rndInt : this.randomIntFromInterval(1, 3)},()=>{
            console.log(this.state.rndInt)
        })
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.updateWindowDimentions);
    }
    
    randomIntFromInterval = (min, max) =>{ // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min)
    }


    updateWindowDimentions(){
        this.setState({
                width: window.innerWidth + 'px',
                height : (window.innerHeight - 120) + 'px'
        })
        console.log("Size :" , `${this.state.width} x ${this.state.height} `)
    }
    handleClose = () => {

        document.getElementById("myModal").style.display = "none"

    }

    onSuggestSelect(suggest) {

    }
    changeToEditView(e) {
        this.setState({ addressComp: false })
    }
    handleBlur() {
        this.setState({ addressComp: true })
    }
    handleDate(e, date) {
        this.setState({
            dateofbirth: date.toString()
        })
    }
    handleSelect(event, index, value) {
        this.setState({
            gender: value
        })
    }
    onChange(e, value) {
        this.setState({
            [e.target.name]: value
        })

    }
    handleClick = () => {
        localStorage.setItem('landingTabs', 'userName1')
        this.setState({
            landingTabs: 'userName1'
        })
    }
    handleRegister = () => {
        localStorage.setItem('landingTabs', 'cardNo')
        this.setState({
            landingTabs: 'cardNo'
        })
    }
    componentWillReceiveProps(nextProps) {
        // if (nextProps.managestate === true) {
        //     let lo = document.getElementById("signin")
        //     lo.classList.add("active")

        //     let lo1 = document.getElementById("signin1")
        //     lo1.classList.add("active")

        //     let cd = document.getElementById("cardno")
        //     cd.classList.remove("active")

        //     let cd1 = document.getElementById("cardno1")
        //     cd1.classList.remove("active")
        // }

        // else {
        //     let lo = document.getElementById("signin")
        //     lo.classList.remove("active")

        //     let lo1 = document.getElementById("signin1")
        //     lo1.classList.remove("active")

        //     let cd = document.getElementById("cardno")
        //     cd.classList.add("active")

        //     let cd1 = document.getElementById("cardno1")
        //     cd1.classList.add("active")
        // }
    }
    onEnterPress = (e) => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            e.preventDefault();
            this.handleLogin();
        }
    }

    handelvalidateusername = (e, value) => {
        if (e.target.name === "userName" && value.length !== 0) {
            $(function () {
                $('#uName').on('keypress', function (e) {

                    if (e.which === 32)
                        return false;
                });
            });
            // if ((e.target.value.length) >= 6) {
            this.setState({
                userName: value
            }, () => {
                if (this.state.userName.length !== 0 && this.state.password.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
            // }else {
            //     this.setState({
            //         correctUsername: false
            //     })
            // }
        } else {
            this.setState({
                disabled: true
            })
        }
    }

    handelvalidatepassword = (e, value) => {
        if (e.target.name === "password" && value.length !== 0) {
            // if ((e.target.value.length) >= 8) {
            this.setState({
                password: value
            }, () => {
                if (this.state.userName.length !== 0 && this.state.password.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
            // }else {
            //     this.setState({
            //         correctPassword: false
            //     })
            // }
        } else {
            this.setState({
                disabled: true
            })
        }
    }
    storeCard() {
        // this.props.history.push('/activate-card')
        this.setState({
            disabled: false

        })

        if (this.state.cardType === "A") {
            this.setState({
                openModal: true
            })
        }
        else if (this.state.cardType === "G" || this.state.cardType === "R") {
            this.props.history.push('/activate-card')
        }
        else {
            this.setState({
                disabled: true
            })

            setTimeout(function () {
                window.location.reload(1);
            }, 3000);
        }

        if (this.state.cardType === "G" || this.state.cardType === "R") {
            JSON.stringify(localStorage.setItem('step', 0))
            this.props.history.push('/activate-card')
        }

    }
    handleOldUser = () => {
        this.setState({
            existingUser: "yes",
            stepIndex: 1,
        }, () => {
            JSON.stringify(localStorage.setItem('step', 1))
            localStorage.setItem('existingUser', 'yes')
            setTimeout(() => {
                this.props.history.push('/activate-card')
            }, 500)

        })
    }
    handleNewUser = () => {
        this.setState({
            existingUser: "no",
            stepIndex: 1,
        }, () => {
            JSON.stringify(localStorage.setItem('step', 1))
            localStorage.setItem('existingUser', 'no')
            setTimeout(() => {
                this.props.history.push('/activate-card')
            }, 500)
        })
    }
    async checkCardNumber(e) {

        
        if (this.state.verification === true && this.state.mobileverification === true) {


            this.setState({
                // disabled: false

            })
        }
        else {
            this.setState({
                disabled: true
            })
        }
        let _this = this
        let string = e.target.value;
        const cardNumber = string.replace(/-/g, "");
        const actualCardNumber = cardNumber.replace(/_/g, "");


        JSON.stringify(localStorage.setItem('cdNo', actualCardNumber))
        const { publicKey } = this.props
        if (actualCardNumber.length >= 16) {
      //  now validation will be via verify card api below code not needed for prod or test

            // if(!actualCardNumber.startsWith('41996500')){
            //     toast.error(('Invalid Card Number'), {
            //         position: "top-right",
            //         draggablePercent: 60,
            //         autoClose: 3000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: false
            //     });
            //     return ;
            // }

            this.setState({ cardVerified: true, rederFeedback: false, cardno: cardNumber, mobiledisable: true, title: "Invalid Card Number" })

            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);
                let encrypted = encrypt.encrypt(cardNumber);
                this.props.storeCardNumber(encrypted)
                localStorage.setItem("cardNumber", encrypted)
                this.setState({ cardNumber: encrypted })
                const state = {
                    cardNumber: encrypted,
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
                }
                let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
                let gvvid = getClientId();
                let traceId = getClientId();
                await fetch(plink + services.verify_card, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'clientId': gvvid,
                        'clientSecret': getClientSecret(gvvid,actualCardNumber), 
                         'X-Trace-Id': traceId,
                         'X-Client-APP':buildClientHeader(),
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201) {

                            response.json().then(function (object) {

                                _this.setState({
                                    cardVerified: false, rederFeedback: true, verification: true, mobiledisable: false, title: '', cardVerificationDone: true,
                                    cardStatus: object.cardStatus
                                })
                                let dob = object.specialDate
                                JSON.stringify(localStorage.setItem('dob', dob))
                                localStorage.setItem("cardType", object.cardType)
                                if (object.cardType !== "A") {


                                    let dArr = dob.split("-");  // ex input "2010-01-18"


                                    var res = dArr[2].substring(0) + dArr[1].substring(0);

                                    _this.setState({
                                        dob: res,
                                        cardType: object.cardType,
                                        disabled: true,
                                    })
                                }
                                else {

                                    localStorage.setItem("cardType", _this.state.cardType)
                                    _this.setState({
                                        disabled: false,
                                        cardType: object.cardType,
                                    })
                                }

                                let state = {
                                    cardNumber: object.cardNumber,
                                    expiryDate: object.expiryDate,
                                    firstName: object.firstName,
                                    lastName: object.lastName,
                                }
                                localStorage.setItem("accountId", object.accountId)
                                localStorage.setItem("expiry", object.expiryDate)
                                localStorage.setItem("cardTypes", _this.state.cardType)
                                localStorage.setItem("cardProgram", object.cardProgram)
                                localStorage.setItem("existingUser", object.accountIdExist)
                                _this.props.getactivation(state)
                            })

                        }
                        // else if (response.status === 422) {
                        //     response.json()
                        //     .then(json => {
                        //         let message = json.message? json.message: response.headers.get('message')
                        //     //document.getElementById('setpassword').style.display = "block"
                        //     toast.error(message, {
                        //         position: "top-right",
                        //         autoClose: 3000,
                        //         hideProgressBar: false,
                        //         closeOnClick: true,
                        //         pauseOnHover: true,
                        //         draggable: true,
                        //         draggablePercent: 60
                        //     })
                        // })}
                        else {
                            _this.setState({ cardVerified: false, rederFeedback: true, verification: false, mobiledisable: true, title: "Invalid Card Number" })
                            // eslint-disable-next-line
                            toast.error(response.headers.get('message')), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            };

                        }
                    })
            }
        }
        else {
            if (actualCardNumber.length < 16 )
                // toast.error(('Invalid Card Number'), {
                //     position: "top-right",
                //     draggablePercent: 60,
                //     autoClose: 3000,
                //     hideProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     draggable: false
                // });
                this.setState({
                    verification: false,
                })
        }

    }
    checkMobileNumber(e) {

        if (this.state.verification === true && this.state.mobileverification === true) {


            this.setState({
                // disabled: false

            })
        }
        else {
            this.setState({
                disabled: true
            })
        }

        if (e.target.value.length >= 4) {

            this.setState({ mobilecardVerified: true, mobilerederFeedback: false, disabled: false, })
            if (e.target.value === this.state.dob) {

                this.setState({ mobilecardVerified: false, mobilerederFeedback: true, mobileverification: true, mobileVerificationDone: true, })
            } else {
                this.setState({ mobilecardVerified: false, mobilerederFeedback: true, mobileverification: false, disabled: true })
            }
        }
        else{
            this.setState({
                mobileverification: false,
            })
        }
    }
    handleModal(e) {
        if (e) { e.preventDefault() }
        this.setState({ open: !this.state.open })
    }

    closeUserModal = () => {
        this.setState({
            openModal: false
        })
    }
     
    onFieldChange = (e, value) => {
        this.setState({
            email: value
        },()=>{
            console.log(this.state.email)
        })

    }

    toggleModal = () => this.setState({
        showModal: !this.state.showModal
      })

      handleSendLink = () => {
        let _this = this 
        let state = {
            emailId: this.state.email
        }
        let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 

        let gsid = getClientId();
        let traceId = getClientId();

        fetch(plink + services.send_api_link, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': gsid,
                'clientSecret': getClientSecret(gsid,this.state.emailId), 
                 'X-Trace-Id': traceId,
                 'X-Client-APP':buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(
                function (response) {
                    if (response.status === 200 || response.status === 201 || response.status === 204) {
                        _this.setState({
                            showModal : false,
                            email : '',
                        })
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                    else if (response.status === 400){
                    toast.error("Incorrect Email ID.", {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    }
                    else {
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                }
            )
    }
    render() {
        const { cardVerified, loader, verification, rederFeedback, mobilecardVerified, mobileverification, mobilerederFeedback } = this.state
        console.log("Height in here " , this.state.height)
        console.log("Email " , this.state.emailId)
        return (
            <div style={{ paddingTop: 10 }} className="" >
                
                <GusetNavbar />
                <div className="container" style={{  backgroundColor: 'transparent' }}>
                    {this.state.openModal && <UserModal
                        open={this.state.openModal}
                        onClose={this.closeUserModal}
                        handleOld={this.handleOldUser}
                        handleNew={this.handleNewUser}
                    />}
                    <ToastContainer
                        draggablePercent={60}
                        position="top-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable={false}
                        pauseOnHover
                    />
                    <div 
    
                        className={`modal WelcomeModal ${this.state.showModal ? 'show' : ''}`} 
                        style={{
                            display: `${this.state.showModal ? 'block' : 'none'}`,
                            backgroundColor : "rgba(12,12,12,.5)"
                            }}
                        id="WelcomeModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header" style={{borderBottom: "0px"}}>
                            <div className="camera-box">
                                <h5 className="modal-title" id="exampleModalLabel">Download Mobile App</h5>
                            </div> 
                            <button type="button" class="close" onClick={this.toggleModal} data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>                                     
                            </div>
                            <div className="modal-body">
                                <p>The SIMS Visa Prepaid App is now available.  You can download the mobile App by clicking on the logos below. </p>
                                <div className="col-sm-12 ">
                                    <div className="row">
                                        <div className="col-sm-8" style={{ paddingLeft: "5px" }} >
                        
                                                    <TextField
                                                        hintText="Email"
                                                        floatingLabelText="Email"
                                                        type="text"
                                                        name="email"
                                                        maxLength="50"
                                                        autoComplete='off'
                                                        onChange={this.onFieldChange}
                                                        className="my-className"
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        autoFocus={true}
                                                        fullWidth
                                                    />

                                        </div>
                                        <div className="col-sm-4" style={{ marginTop: "25px", padding: "0px" }}>
                                            <RaisedButton
                                                label="Send App Link"
                                                labelColor="#000"
                                                className="btn-std"
                                                // style={styles.buttonStyle}
                                                buttonStyle={{ height: "30px", lineHeight: "0px" }}
                                                labelStyle={{ paddingLeft: "12px", paddingRight: "12px", textTransform: "capitalize" }}
                                                onClick={this.handleSendLink.bind(this)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                <p className='mt-4 pb-1'><a href="https://play.google.com/store/apps/details?id=com.oxy.sims" target="_blank"><img src={android} style={{height:'55px' , marginRight: "6px"}} /></a> <a href="https://apps.apple.com/in/app/simsmetal/id1670414151"  target="_blank"><img src={ios} style={{height:'55px'}} /> </a></p>
                                <p className='mt-1 pb-1'>On the App, you can perform all the functions that are available on the website klickex.co.nz such as Card Activation, Registration, Lock/Unlock card, Change PIN, Transaction History, Print Statement and much more.</p>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="col-sm-12 " >
                        <div className="row" >
                            <div className="col-md-6 card-images nopaddingleft pr-0 pt-2" >

                                {/* <div className="simstitle mt-5">THE CARD <br />WITH CHOICE</div>
                                <div className="simsrect"> </div>
                                <div className='mt-5 mb-4'>
                                    <RaisedButton
                                        label="Download App"
                                        type="button"
                                        className="std-btn ml-2"
                                        backgroundColor="rgb(237, 143, 64)"
                                        labelColor="#fff"
                                        onClick={this.toggleModal}
                                        buttonStyle={{ borderRadius: 16 , padding: "0 20px 0px 20px"  }}
                                        style={{ borderRadius: 16 , height: "46px" , lineHeight: "46px"  }}
                                    />                                   
                                </div> */}

                            { this.state.rndInt >=2 ?
                            <Carousel autoPlay infiniteLoop showThumbs={false} showArrows={false}>
                                <div>
                                    <img src={carousel1} alt="Image1" />
                                    {/* <p className="legend">
                                        Legend
                                    </p> */}
                                </div>
                                <div>
                                    <img src={carousel2} alt="Image2" />
                                    {/* <p className="legend">
                                        Legend
                                    </p> */}
                                </div>
                                <div>
                                    <img src={carousel3} alt="Image3" />
                                    {/* <p className="legend">
                                        Legend
                                    </p> */}
                                </div>
                                <div>
                                    <img src={carousel4} alt="Image4" />
                                    {/* <p className="legend">
                                        Legend
                                    </p> */}
                                </div>
                            </Carousel>
                        :
                        <Carousel autoPlay infiniteLoop showThumbs={false} showArrows={false}>
                            <div>
                                <img src={carousel5} alt="Image5" />
                                {/* <p className="legend">
                                    Legend
                                </p> */}
                            </div>
                            <div>
                                <img src={carousel6} alt="Image6" />
                                {/* <p className="legend">
                                    Legend
                                </p> */}
                            </div>
                            <div>
                                <img src={carousel7} alt="Image7" />
                                {/* <p className="legend">
                                    Legend
                                </p> */}
                            </div>
                            <div>
                                <img src={carousel8} alt="Image8" />
                                {/* <p className="legend">
                                    Legend
                                </p> */}
                            </div>
                        </Carousel>
                        } 

                            </div>
                            {/* <div className="col-md-6 regtabs" >
                            <div className="row" > */}
                            {/* <div className="col-sm-12 bhoechie-tab-container">
                                    <div className="row" > */}
                            {/* <div className="col-lg-12 col-md-12 col-sm-12 bhoechie-tab-menu">
                                            <div className="list-group flex-row">
                                                <a className="col-md-6 list-group-item active text-center" id="cardno1" style={{ padding: "12px" }} onClick={this.handleRegister.bind(this)} >
                                                    <i className="fa fa-user-plus" aria-hidden="true" style={{ fontSize: 24, display: "block" }}></i>
                                                    <span>Activate / Register Your Card</span>
                                                </a>
                                                <a className="col-md-6 list-group-item text-center " id="signin1" style={{ padding: "12px" }} onClick={this.handleClick.bind(this)} >
                                                    <i className="fa fa-sign-in" aria-hidden="true" style={{ fontSize: 24, display: "block" }}></i>
                                                    <span>Sign In To Your Card </span>
                                                </a>

                                            </div>
                                        </div> */}

                            {/* <div className="col-lg-12 col-md-12 col-sm-12 bhoechie-tab" style={{ minHeight: 300 }}>
                                            <div className="bhoechie-tab-content active " id="cardno">
                                                <CardNumber />
                                            </div> */}

                            {/* <div className="bhoechie-tab-content" id="signin">
                                                {loader ? <div>
                                                    <Loader />
                                                </div> :
                                                    <Signin />}

                                            </div> */}
                            {/* </div>
                                    </div> */}
                            {/* </div>
                            </div> */}
                            <div className="col-md-6 pl-0 mr-0 pr-0" >
                                <div className="d-flex flex-row-reverse" style={{ marginTop: 40 }}>
                                    <div className="loginbox col-auto justify-content-end  p-4 mb-5">
                                        <div className="col-12 mt-3">
                                            <div className="logmainheading mb-3">Activate/Register <span style={{ color: '#0190f7' }}> Your Card </span></div>
                                        </div>

                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-11">

                                                    <div className="group">
                                                        <InputMask mask="9999-9999-9999-9999" autoComplete='none' placeholder="1234-1234-1234-1234" onChange={this.checkCardNumber.bind(this)}
                                                            id="cardNumber" ref="item" />
                                                        <span className="highlight"></span>
                                                        <span className="bar"></span>
                                                        <label>Enter Card Number</label>
                                                    </div>
                                               
                                                    {cardVerified ? <LoaderSmall /> : null}
                                                    {rederFeedback ? <div className="feedback">
                                                        {verification ? <i className="fa fa-check" aria-hidden="true" style={{ color: "green", marginLeft: "3px" }}></i> :
                                                            <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>}
                                                    </div> : null}

                                                    {/*  */}
                                                </div>
                                            </div>
                                        </div>
                                        {(this.state.cardType === "G" || this.state.cardType === "R") ?
                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col-11">
                                                        <label style={{ fontSize: "14px", }}>Date Of Birth </label>
                                                        <div className="group" style={{ marginTop: "0px" }}>
                                                            <InputMask mask="9999" placeholder="DDMM" title={this.state.title} autoComplete='none' readOnly={this.state.mobiledisable} onChange={this.checkMobileNumber.bind(this)}
                                                                id="phonenumber" />
                                                        </div>
                                                   
                                                        {mobilecardVerified ? <LoaderSmall /> : null}
                                                        {mobilerederFeedback ? <div className="feedback">
                                                            {mobileverification ? <i className="fa fa-check" aria-hidden="true" style={{ color: "green" }}></i> :
                                                                <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>}
                                                        </div> : null}
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div> </div>}



                                        {/* <div className="col-sm-1 group-icon">
                                                <i className="fa fa-calendar text-dark " aria-hidden="true" ></i>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="group">
                                                    <InputMask mask="99/99" placeholder="12/18" />
                                                    <span className="highlight"></span>
                                                    <span className="bar"></span>
                                                    <label>Expiration Date</label>
                                                </div>
                                            </div> */}


                                        <div className='col-12 mt-4'>
                                            <RaisedButton
                                                disabled={this.state.disabled}
                                                label="Submit"
                                                className="card-submit btn-std"
                                                backgroundColor="#FFCE39"
                                                labelColor="#115876"
                                                buttonStyle={{ borderRadius: 50 }}
                                                style={{ borderRadius: 50 }}


                                                onClick={this.storeCard}
                                            />
                                            <Link to='/login' className='simplelink' style={{ marginLeft: '15px' , display: 'block' }}> Sign in to your card account
                                                <i style={{ color: "#115876", fontSize: "17px" }} className="fa fa-arrow-circle-right ml-2"></i>
                                            </Link>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-5" >
                            <div className="col-md-12 home-desc" >
                                <section className="row" id="features" style={{ padding: "15px 0px" }}>
                                    <div className="col-lg-4 col-md-4 col-sm-12 bg-white text-dark">
                                        <div className="p-5 text-center wow zoomIn" data-wow-delay=".1s">
                                            {/* <img src={activateImg} alt='activate' /> */}
                                            <div className="h5 mt-3">Cardholder Benefits</div>
                                            <p className="mt-1" style={{ margin: "0 0 0px" }}>Accessible Anywhere</p>
                                            <p className="mt-1" style={{ margin: "0 0 0px" }}>Worldwide Visa Acceptance - 24,000,000+ locations</p>
                                            <p className="mt-1" style={{ margin: "0 0 0px" }}>Secure Online Shopping</p>
                                            <p className="mt-1" style={{ margin: "0 0 0px" }}>Use in New Zealand and Overseas</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 bg-grey text-dark">

                                        <div className="p-5 text-center wow zoomIn" data-wow-delay=".3s">
                                            {/* <img src={manageImg} alt='manage' /> */}
                                            <div className="h5 mt-3">
                                                {/* <a onClick={this.handleshowdiv} > */}
                                                Manage Your card
                                                {/* </a> */}
                                            </div>
                                            <p className="mt-1" style={{ margin: "0 0 0px" }}>Check Your Card Balance</p>
                                            <p className="mt-1" style={{ margin: "0 0 0px" }}>View Your Transaction History</p>
                                            <p className="mt-1" style={{ margin: "0 0 0px" }}>Set and/or Change Your PIN</p>
                                            <p className="mt-1" style={{ margin: "0 0 0px" }}>Update Your Personal Details</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 bg-white text-dark">
                                        <div className="p-5 text-center wow zoomIn" data-wow-delay=".5s">
                                            {/* <img src={customerImg} alt='Customer' /> */}
                                            <div className="h5 mt-3">Customer Service </div>
                                            <p className="mt-1" style={{ margin: "0 0 0px" }}>24-7 Online Access</p>
                                            <p className="mt-1" style={{ margin: "0 0 0px" }}>Email Customer Service </p>
                                            {/* <p className="mt-1" style={{ margin: "0 0 0px" }}>Automated IVR </p> */}
                                            {/* <p className="mt-1" style={{ margin: "0 0 0px" }}>1800 914 332  </p> */}
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));


// WEBPACK FOOTER //
// ./src/components/register/register.jsx